<template>
    <div class="md-mls" :class="theme">
        <hr v-if="theme !== 'broker'" class="line" />
        <div v-if="readmore" class="readmore" @click="readMore">
            <span
                :class="{ open: openReadMore }"
                class="iconfont icon-more_arrow"
            ></span>
            <span>
                {{
                    openReadMore
                        ? $t('md-detail-info.readLessInfo')
                        : $t('md-detail-info.readMoreInfo')
                }}
            </span>
        </div>
        <div class="mls-container" :class="{ padding: readmore }">
            <!-- SITE-15435 -->
            <template v-if="info.mlsOrg && info.mlsOrg.id == 128">
                <div class="mls-img img-content">
                    <a
                        :href="info.chimeExternalLink || null"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <site-img
                            dir="height"
                            src="https://www.realtor.ca/images/en-ca/powered_by_realtor.svg"
                            :alt="$t('md-detail-info.poweredByRealtorca')"
                        ></site-img>
                    </a>
                </div>
            </template>
            <template v-else-if="info.mlsOrg && showlogo">
                <div class="mls-img img-content">
                    <site-img
                        dir="height"
                        :alt="info.mlsOrg.name"
                        :src="
                            isMobileSize
                                ? info.mlsOrg.smallLogo
                                : info.mlsOrg.logo
                        "
                    ></site-img>
                </div>
            </template>
            <div class="text-container">
                <div
                    v-if="info.mlsOrg && info.mlsOrg.copyright"
                    class="mls-copyright"
                >
                    <div v-html="info.mlsOrg.copyright"></div>
                </div>
                <Provided v-if="provided" :theme="provided"></Provided>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import Provided from './provided';

export default {
    emits: ['readMore'],
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {};
    },
    props: {
        readmore: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: ''
        },
        provided: {
            default: ''
        }
    },
    created() {
        if (this.info.mlsOrg && this.info.mlsOrg.copyright) {
            this.info.mlsOrg.copyright = this.info.mlsOrg.copyright.replace(
                "${.now?string('yyyy')}",
                new Date().getFullYear()
            );
        }
    },
    methods: {
        readMore() {
            this.$emit('readMore');
        }
    },
    computed: {
        ...mapState({
            "info": store => store.listingDetail.info || {},
            "openReadMore": store => store.openReadMore
        }),
        showlogo() {
            if (!this.info.mlsOrg) {
                return false;
            }
            if (!this.isMobileSize && this.info.mlsOrg.logo) {
                return true; 
            }
            if (this.isMobileSize && this.info.mlsOrg.smallLogo) {
                return true; 
            }
            return false;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        
    },
    components: { Provided }
};
</script>
<style lang="scss">
@import '../../theme/media.scss';
@import '@/theme/mixin.scss';
.md-mls {
    clear: both;
    overflow: hidden;
    hr {
        height: 1px;
        border: none;
        border-top: 1px solid #e5e8f1;
        margin: 40px 0;
    }
    .readmore {
        @include color-theme();
        cursor: pointer;
        text-align: center;
        .iconfont {
            display: inline-block;
            transform: rotate(90deg);
            font-size: 12px;
            &.open {
                transform: rotate(-90deg);
            }
        }
    }
    &.broker {
        .mls-container {
            .text-container {
                .mls-copyright {
                    font-size: 14px;
                    line-height: 20px;
                    color: #a8a8a8;
                }
            }
            .mls-provided-container .mls-provided {
                margin-top: 10px;
                color: #505050;
            }
        }
    }
    .mls-container {
        &.padding {
            width: calc(100% - 120px);
        }
        .mls-img {
            position: relative;
            height: 40px;
            overflow: hidden;
            margin-bottom: 10px;
            img {
                height: 100%;
            }
        }
        .text-container {
            .mls-copyright {
                font-size: 14px;
                line-height: 20px;
                color: var(--color-label);
            }
        }
        .mls-provided-container .mls-provided {
            margin-top: 10px;
            color: var(--color-label);
        }
    }
    @include media-800 {
        .mls-container {
            .text-container {
                .mls-copyright {
                    font-size: 13px;
                }
            }
        }
    }
    @media (min-width: 601px) {
        .readmore {
            float: right;
            &:hover {
                @include color-hover();
            }
        }
    }
    @include media-600 {
        .readmore {
            margin-bottom: 20px;
        }
        .mls-container {
            &.padding {
                width: 100%;
            }
        }
    }
}
.md-mls.classic {
    hr {
        margin: 0px 0px 20px 0;
    }
    .mls-container {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        .mls-img {
            margin: 0px 20px 0px 0px;
        }
    }
    @include media-600 {
        hr {
            margin: 0px;
        }
        .readmore {
            padding-bottom: 20px;
            padding-top: 20px;
            margin-bottom: 0px;
        }
    }
}
</style>
